import { render } from "./modal-edit-jawaban.vue?vue&type=template&id=a642e410&scoped=true"
import script from "./modal-edit-jawaban.vue?vue&type=script&lang=js"
export * from "./modal-edit-jawaban.vue?vue&type=script&lang=js"

import "./modal-edit-jawaban.vue?vue&type=style&index=0&id=a642e410&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a642e410"]])

export default __exports__